import AbstractMaintain from "../maintenance/AbstractMaintain";
import UsersService from "../../../services/UsersService";

// Department billing codes for PropertyWare
const DEPARTMENT_OPTIONS = [
  { id: '31010', name: '31010 - General Maintenance' },
  { id: '32010', name: '32010 - Grounds Maintenance' },
  { id: '33010', name: '33010 - Cleaning Maintenance' },
  { id: '34010', name: '34010 - Painting' },
  { id: '31020', name: '31020 - Repair Maintenance' },
];

const AdministerUsers = (props) => {
  const columnDefs = [
    {
      Header: "First Name",
      accessor: "firstname",
      type: "text",
      isEditable: true,
      isRequired: true,
    },
    {
      Header: "Last Name",
      accessor: "lastname",
      type: "text",
      isEditable: true,
      isRequired: true,
    },
    {
      Header: "Login",
      accessor: "login",
      type: "text",
      isEditable: true,
      isRequired: true,
    },
    {
      Header: "Is Admin?",
      accessor: "is_admin",
      type: "toggle",
      isEditable: true,
      isRequired: false,
      defaultValue: false,
    },
    {
      Header: "Is Enabled?",
      accessor: "is_enabled",
      type: "toggle",
      isEditable: true,
      isRequired: false,
      defaultValue: true,
    },
    {
      Header: "Is API User? (prevents login)",
      accessor: "is_api_user",
      type: "toggle",
      isEditable: true,
      isRequired: false,
      defaultValue: false,
    },
    {
      Header: "Department",
      accessor: "department_code",
      type: "select",
      isEditable: true,
      isRequired: false,
      lookupFunction: async () => ({ data: DEPARTMENT_OPTIONS }),
      defaultValue: { id: '31020', name: '31020 - Repair Maintenance' },
    },
    {
      Header: "Password",
      accessor: "setpassword",
      type: "setpassword",
      isEditable: true,
      isRequired: false,
    }
  ];
  return AbstractMaintain(props, {
    columnDefs,
    dataService: UsersService,
    dataDescriptionStr: "Users",
  });
};

export default AdministerUsers;